import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Upgrade from "./components/upgrade";
import Home from "./components/Home";
import Privacy from "./components/Privacy";
import DeleteAccount from "./components/DeleteAccount";
import Help from "./components/Help";
import { ChakraProvider } from "@chakra-ui/react";
import system from "./theme";

const App: React.FC = () => {
    return (
        <BrowserRouter>
            <ChakraProvider value={system}>
                <Routes>
                    <Route path="/upgrade" element={<Upgrade />} />
                    <Route path="/" element={<Home />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/delete" element={<DeleteAccount />} />
                    <Route path="/help" element={<Help />} />
                    {/* New app routes */}
                </Routes>
            </ChakraProvider>
        </BrowserRouter>
    );
};

export default App;
